
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_29243_135816)"}},[_c('path',{attrs:{"d":"M19 10v.095c-.014 1.283-1.181 2.155-2.465 2.155h-3.441a1.688 1.688 0 00-1.653 2.036c.074.358.229.703.38 1.05.215.486.425.967.425 1.477 0 1.118-.759 2.134-1.877 2.18-.123.004-.246.007-.373.007C5.03 19 1 14.971 1 10a9 9 0 019-9 9 9 0 019 9zM5.5 11.125a1.124 1.124 0 10-2.25 0 1.124 1.124 0 102.25 0zm0-3.375a1.124 1.124 0 100-2.25 1.124 1.124 0 100 2.25zm5.625-3.375a1.124 1.124 0 10-2.25 0 1.124 1.124 0 102.25 0zM14.5 7.75a1.124 1.124 0 100-2.25 1.124 1.124 0 100 2.25z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_29243_135816"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1 1)","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    